import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useWorkspaceEditorParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = useMemo(
    () => ({
      workspaceKey: searchParams.get("workspaceKey") || "default",
      branch: searchParams.get("branch") || "",
      group: searchParams.get("group") || "",
    }),
    [searchParams]
  );

  const setParam = useCallback(
    (key: "workspaceKey" | "branch" | "group", val: string) => {
      const current = searchParams.get(key) || "";
      if ((val || "") === current) return;

      const next = new URLSearchParams(searchParams);
      if (!val) next.delete(key);
      else next.set(key, val);

      if (next.toString() === searchParams.toString()) return;
      setSearchParams(next);
    },
    [searchParams, setSearchParams]
  );

  return { ...value, setParam };
};
